/** @format */

import React from 'react'
import { useTranslation } from 'react-i18next'
import { Route, Redirect } from 'react-router-dom'

import FullPageLayout from '../fullPageLayout'

const FullPageLayoutSessionRoute = ({ render, ...rest }) => {
  const { t } = useTranslation('routes')

  return (
    <Route
      {...rest}
      render={(matchProps) =>
        localStorage.getItem('token') ? (
          <Redirect
            to={{
              pathname: t('routes:store_route', '/store'),
            }}
          />
        ) : (
          <FullPageLayout>{render(matchProps)}</FullPageLayout>
        )
      }
    />
  )
}

export default FullPageLayoutSessionRoute
